// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "3287fde14cac";
export const BUILD_VERSION_NUMBER = 49;
